import { Injectable, Inject } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {from, Observable} from 'rxjs';
import {
 MSAL_GUARD_CONFIG,
  MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG,
   MsalGuardConfiguration, MsalInterceptorConfiguration,
  MsalService
} from '@azure/msal-angular';
import {AuthError, Configuration, InteractionRequiredAuthError} from 'msal';

import {
  IPublicClientApplication,
  EndSessionRequest,
  AuthenticationResult,
  RedirectRequest,
  PublicClientApplication,
  SilentRequest,
  PopupRequest,
  SsoSilentRequest,
  Logger,
  WrapperSKU
} from "@azure/msal-browser";

import { Location} from '@angular/common';

import * as _ from 'lodash';
import {AppConsts} from "./appConsts";
import Swal from 'sweetalert2';

@Injectable()
export class RouteGuard implements CanActivate {
  app;
  constructor(
    @Inject(MSAL_INTERCEPTOR_CONFIG) private msalInterceptorConfig: MsalInterceptorConfiguration,
    @Inject(MSAL_GUARD_CONFIG) private guardConfig: MsalGuardConfiguration,
    @Inject(MSAL_INSTANCE) public instance: IPublicClientApplication,
    private authService: MsalService,
                 private router: Router,
                 private location: Location){


}

  async init(state) {
    try {
      let tokenResponse = await this.instance.handleRedirectPromise();
      let accountObj;
      if (tokenResponse) {
        accountObj = tokenResponse.account;
      } else {
        accountObj = this.instance.getAllAccounts()[0];
      }

      if (accountObj && tokenResponse) {
      } else if (accountObj) {
        try {
          tokenResponse = await this.instance.acquireTokenSilent({
            account: this.instance.getAllAccounts()[0],
            scopes: ["user.read"]
          })
        } catch (err) {
          await this.instance.acquireTokenRedirect({scopes: ["user.read"]});
        }
      } else {
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        return Promise.resolve('')
      }
    } catch (error) {
      console.error("[AuthService.init] Failed to handleRedirectPromise()", error)
      return Promise.reject(error);
    }
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<any> {
    return this.init(state).then(() => true);
  }
  
}
